import { StakeBill } from "@/interface"
import useConnectWallet from "@/store/wallet/useConnectWallet"
import { useCallback, useState } from "react"

/**
 * useGetStakes - 获取单个质押记录详情 Hook
 * 
 * 用于调用 RegularStaking 合约的 stakes 方法获取指定质押记录的详细信息。
 * 
 * @returns {Object} 返回获取方法、数据和加载状态
 *   - getStakes: 执行获取质押记录的函数
 *   - stakesData: 质押记录数据（StakeBill）
 *   - stakesLod: 加载状态
 */
const useGetStakes = () => {
    // 存放数据
    const [stakesData, setData] = useState<StakeBill>({
        id: BigInt(0), // 质押ID
        initialAmount: BigInt(0), // 初始质押金额
        amount: BigInt(0), // 当前可用金额
        totalReward: BigInt(0), // 累计收益
        startTime: BigInt(0), // 质押开始时间
        endTime: BigInt(0), // 质押结束时间
        lastTime: BigInt(0), // 最近一次提取时间
        monthlyRate: BigInt(0), // 月利率
        unlockCycle: BigInt(0), // 质押周期
        multiple: BigInt(0), // 算力矿池倍数
        pool: BigInt(0), // 当前算力
        isPrivate: false // 是否是私募订单
    })
    // loading
    const [stakesLod, setLoading] = useState(false)
    // 获取合约实例和地址
    const { contractEvm: { RegularStaking }, address } = useConnectWallet()

    /**
     * 获取质押记录详情
     * @param id - 质押记录的 ID
     * @returns 返回质押记录详情（StakeBill）
     */
    const getStakes = useCallback(async (id: bigint) => {
        setLoading(true)
        if (RegularStaking) {
            try {
                // 调用合约的 stakes 方法获取数据
                const data = await RegularStaking.stakes(address, id)
                // 保存数据
                setData(data)
                setLoading(false)
                return data
            } catch (e) {
                console.log('useGetStakes', e);
            }
        }
        setLoading(false)
    }, [RegularStaking, address])

    return { stakesData, stakesLod, getStakes }
}

export default useGetStakes
